import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Home from './pages/Home'
import NewsHomePage from './pages/news/HomeNewsPage'
import SearchNewsPage from './pages/news/SearchNewsPage'
import NewsListedByCategoryPage from './pages/news/NewsListedByCategoryPage'
import ListCareers from './pages/newsModule/ListCareers'
import AddNews from './pages/newsModule/AddNews'
import EditNews from './pages/newsModule/EditNews'
import ReviewApprove from './pages/newsModule/ReviewApprove'
import ReviewPublish from './pages/newsModule/ReviewPublish'
import ViewNewsPage from './pages/news/ViewNewsPage'
import Published from './pages/newsModule/Management/Published'
import PendingApproval from './pages/newsModule/Management/PendingApproval'
import PendingPublished from './pages/newsModule/Management/PendingPublished'
import MyNews from './pages/newsModule/Management/MyNews'
import NotFound from './pages/NotFound'
import ProtectedRoute from './protectedRoutes'
import GeneralRoute from './generalRoutes'
import ViewPostGraduate from './pages/PostGraduate/ViewPostGraduatePage'
import PostGraduateSubscribe from './pages/PostGraduate/SubscribePage'
import Results2022 from './pages/PostGraduate/ResultsPage2022'
import Results2026 from './pages/PostGraduate/ResultsPage2026'
import PostGraduateInauguralClass from './pages/PostGraduate/InauguralClassPage'
import ForgotPasswordPage from './pages/password/ForgotPasswordPage'
import ResetPasswordPage from './pages/password/ResetPasswordPage'
import Highlight from './pages/newsModule/Management/Highlight'
import AddHighlight from './pages/newsModule/AddHighlight'
import EditHighlight from './pages/newsModule/EditHighlight'
import LinesResearchPage from './pages/LinesResearchPage'
import ProjectsPage from './pages/ProjectsPage'
import LaboratoryPage from './pages/LaboratoryPage'
import NoticesPage from './pages/OpportunitiesPage'
import NoticeDetails from './pages/OpportunitiesDetailsPage'
import NoticesSearchPage from './pages/OpportunitiesSearchPage'
import ViewMyNewsById from './pages/newsModule/ViewMyNewsById'
import PostGraduationSearchPage from './pages/PostGraduate/PostGraduationSearchPage'
import ListPostGraduatePage from './pages/PostGraduate/ListPostGraduatePage'

const Routes = () => {
  return (
    <Router>
      <Switch>
        <GeneralRoute exact path="/" component={Home} />
        <Route exact path="/news/" component={NewsHomePage} />
        <Route exact path="/news/search" component={SearchNewsPage} />
        <ProtectedRoute exact path="/news/management" component={Published} />
        <ProtectedRoute
          exact
          path="/news/management/my-news"
          component={MyNews}
        />
        <ProtectedRoute
          exact
          path="/news/management/pending-approval"
          component={PendingApproval}
        />
        <ProtectedRoute
          exact
          path="/news/management/pending-published"
          component={PendingPublished}
        />
        <ProtectedRoute
          exact
          path="/news/management/my-news/:id"
          component={ViewMyNewsById}
        />
        <ProtectedRoute
          exact
          path="/news/review-approve/:id"
          component={ReviewApprove}
        />
        <ProtectedRoute
          exact
          path="/news/review-publish/:id"
          component={ReviewPublish}
        />
        <ProtectedRoute exact path="/news/add-news" component={AddNews} />
        <ProtectedRoute exact path="/news/edit-news/:id" component={EditNews} />
        <Route exact path="/news/careers" component={ListCareers} />
        <Route exact path="/news/blog" component={NewsListedByCategoryPage} />
        <Route
          exact
          path="/news/publications"
          component={NewsListedByCategoryPage}
        />
        <Route
          exact
          path="/news/defenses"
          component={NewsListedByCategoryPage}
        />
        <Route exact path="/news/events" component={NewsListedByCategoryPage} />
        <Route exact path="/news/awards" component={NewsListedByCategoryPage} />
        <Route exact path="/news/careers/:id" component={ViewNewsPage} />
        <Route exact path="/news/blog/:id" component={ViewNewsPage} />
        <Route exact path="/news/publications/:id" component={ViewNewsPage} />
        <Route exact path="/news/defenses/:id" component={ViewNewsPage} />
        <Route exact path="/news/events/:id" component={ViewNewsPage} />
        <Route exact path="/news/awards/:id" component={ViewNewsPage} />
       <Route exact path="/postgraduate" component={ListPostGraduatePage} />
        <Route
          exact
          path="/postgraduate/search"
          component={PostGraduationSearchPage}
        />
        <Route
          exact
          path="/postgraduate/rsc-2022"
          component={ViewPostGraduate}
        />
        <Route
          exact
          path="/postgraduate/rsc-2022/inscricao"
          component={PostGraduateSubscribe}
        />
        <Route
          exact
          path="/postgraduate/rsc-2022/resultados"
          component={Results2022}
        />
        <Route
          exact
          path="/postgraduate/rsc-2026/resultados"
          component={Results2026}
        />

        <Route
          exact
          path="/postgraduate/rsc-2022/aula-magna"
          component={PostGraduateInauguralClass}
        />
        <Route
          exact
          path="/postgraduate/rsc-2026"
          component={ViewPostGraduate}
        />
        <Route exact path="/forgot-password" component={ForgotPasswordPage} />
        <Route exact path="/reset-password" component={ResetPasswordPage} />
        <ProtectedRoute
          exact
          path="/news/management/highlight"
          component={Highlight}
        />
        <ProtectedRoute exact path="/add-highlight" component={AddHighlight} />
        <ProtectedRoute
          exact
          path="/edit-highlight/:id"
          component={EditHighlight}
        />
        <Route exact path="/research" component={LinesResearchPage} />
        <Route exact path="/projects" component={ProjectsPage} />
        <Route exact path="/laboratory" component={LaboratoryPage} />
        <Route exact path="/opportunities" component={NoticesPage} />
        <Route exact path="/opportunities/search" component={NoticesSearchPage} />
        <Route exact path="/opportunities/:id" component={NoticeDetails} />
        <Route exact path="*" component={NotFound} />
      </Switch>
    </Router>
  )
}

export default Routes
